import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import type { Paywall } from "@/react/types/Paywall";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { PAYWALL_NON_DRAFT_STATUSES } from "@circle-react/types/Paywall";

export const usePaywallFilterList = (
  name: string,
  params: { status?: string[]; type?: string[] } = {},
) => {
  const fetchPaywalls = () =>
    reactQueryGet(
      internalApi.paywalls.index({
        params: {
          ...params,
          status: params.status || PAYWALL_NON_DRAFT_STATUSES,
        },
      }),
    );

  const { data: paywallsData = [], isLoading: isPaywallsLoading } = useQuery<
    Paywall[]
  >(name, fetchPaywalls);

  const paywalls = paywallsData.map((record: Paywall) => ({
    label: record.display_name,
    value: record.id.toString(),
  }));

  return {
    paywalls,
    isPaywallsLoading,
  };
};
